export const STORAGE_KEYS = {
  CLIENT_SESSION: 'compliants-client-session',
}

export const ENDPOINTS = {
  CLIENT_SIGNUP: 'api/client/v1/signup',
  COMPLIANT_DETAIL: 'api/client/v1/compliants/{compliantId}',
  COMPLIANT_CHANNEL: 'api/client/v1/compliants/{compliantId}/channel',
  COMPLIANT_MESSAGES: 'api/client/v1/compliants/{compliantId}/messages',
  CHANNEL_MESSAGES: 'api/client/v1/channels/{channelId}/messages',
  COMPLIANT_FAQS: 'api/client/v1/compliants/faqs',
  COMPLIANT_CHANNEL_CONFIG: 'api/compliants/channel-config',
  COMPLIANT_RECEIPT: 'api/client/v1/compliants/{compliantId}/receipt',
};
